export const isTOFlight = (flightId = '') => {
  if (!flightId) {
    return false
  }

  const flightCodeLength = 6
  const stringLength = flightId.length
  const code = flightId.substring(stringLength - flightCodeLength, stringLength)

  return code.includes('TO')
}
